import React from 'react';

import CustomIcon from 'Crow/Form/Field/Custom/Common/CustomIcon/CustomIcon.js';

import style from 'Vulture/View/Sidebar.module.css';

import {
	hasPermission,
	isInitialized
} from 'Vulture/Permissions.js';
import { dlNavigationPush } from 'Vulture/DataLayer';
import { buildTestData, removeWhitespace } from 'Vulture/TestData';

class SidebarView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sidebarClass: 'collapsed'
		};
	}

	checkDataValidity() {
		const {
			app,
		} = this.props;
		let keys = Object.keys(app.state.pendingChanges);
		let dataValid = true;

		keys.forEach((key) => {
			if (key.includes('display_name')) {
				if (app.state.pendingChanges[key] === '') {
					dataValid = false;
				}
			}
		});

		return dataValid;
	}

	render() {
		const {
			app,
			accountUUID,
			accountName
		} = this.props;

		const {
			router,
		} = app.props;

		const {
			mode,
			account,
		} = router.params;

		// Define base sidebar items - available to all roles
		let sidebarItems = [
			{
				name: 'systems',
				label: 'Hierarchy',
				icon: 'sitemap',
				permission: 'property_access'
			},
			{
				name: 'content',
				label: 'Content',
				icon: 'th-list',
				permission: 'property_access'
			},
			{
				name: 'library',
				label: 'Library',
				icon: 'book',
				permission: 'property_access'
			},
			{
				name: 'proof_of_play',
				label: 'Proof of Play',
				icon: 'chart-line',
				permission: 'pop_analytics'
			},
		];

		// Admin/settings items
		let adminItems = [
			{
				name: 'account_settings',
				label: 'Settings',
				icon: 'cog',
				permission: 'settings_access'
			},
			{
				name: 'system_programming',
				label: 'Programming',
				icon: 'layer-group',
				permission: 'programming'
			},
			{
				name: 'accountUsers',
				label: 'Users',
				icon: 'users',
				permission: 'user_management'
			},
			{
				name: 'folder_navigation',
				label: 'Folder Navigation',
				icon: 'leaf',
				permission: 'user_management'
			},
		];

		// If permissions are not yet initialized, show a loading state
		if (!isInitialized()) {
			return (
				<div id="sidebar" className={`${style.sidebar} ${style.collapsed} ${style.loading}`}>
					<div className={style.loadingIndicator}>
						<CustomIcon icon="spinner" spin={true} />
					</div>
				</div>
			);
		}

		// Filter items based on permissions
		const allMenuItems = [...sidebarItems, ...adminItems];
		const visibleMenuItems = allMenuItems.filter(item => {
			const hasPerm = hasPermission(item.permission);
  
			if (item.name === 'folder_navigation') {
			  return hasPerm && accountName === 'Official Test Account';
			}
			
			return hasPerm;
		});

		let sidebarClass = this.state.sidebarClass;
		let sidebarCondition = style.disabled;
		
		if (visibleMenuItems.some(item => item.name === mode) || accountUUID) {
			sidebarCondition = '';
		}

		return (
			<div id="sidebar" className={`${style.sidebar} ${style[sidebarClass]} ${sidebarCondition} ${(this.props.classNameList || []).join(' ')}`}
				onMouseEnter={(e) => {
					if (mode !== 'accounts') {
						e.preventDefault();
						this.setState({
							sidebarClass: 'expanded',
						});
					}
				}}
				onMouseLeave={(e) => {
					e.preventDefault();
					
					this.setState({
						sidebarClass: 'collapsed',
					});
				}}
			>
				<ul className={style.menu}>
						{visibleMenuItems.map((item, i) => (
						<li
							className={mode === item.name ? `${style.active}` : ''}
							key={`sidebarItem_${i}`}
							value={i}
							data-testing-info={buildTestData(`listItem--${removeWhitespace(item.label)}`)}
							onClick={(e) => {
								e.preventDefault();

								dlNavigationPush({
									destination: item.label
								});

								const { app } = this.props;
								
								let handleClick = () => {
									this.setState({
										sidebarClass: 'collapsed',
									});

									let path = `/${item.name}`;
									if (account) {
										path = `/${item.name}/${account}`;
									}

									app.redirect({
										to: path,
									});
								};

								if (app.hasPendingChanges()) {
									const noSaveCB = () => handleClick();
									const saveCB = () => {
										app.saveDataAndCloseModal('IGNORE', handleClick);
									};

									if (mode === 'account_settings'){
										console.log(this.checkDataValidity());
									} else {
										app.openPendingChangesModal('content', noSaveCB, saveCB);
									}
								} else if (app.hasPendingSlideshowChanges()) {
									const noSaveCB = () => handleClick();
									const saveCB = () => {
										app.saveDataAndCloseModal('IGNORE', handleClick);
									};

									app.openPendingChangesModal('content', noSaveCB, saveCB);
								} else {
									handleClick();
								}
							}}
							data-onclick={item.label}
						>
							<div className={style.icon}>
								<CustomIcon icon={item.icon} />
							</div>
							<div className={style.name}>{item.label}</div>
						</li>
					))}
				</ul>
			</div>
		);
	}
}

export default SidebarView;